export default "assets/images/icons/info-8042768d.svg";